const url=import.meta.env.VITE_SUPABASE_URL?.trim();const key=import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();
export const configured=Boolean(url&&key&&!url.includes('your-project')&&!key.includes('replace_me'));
export const env={url:url??'',key:key??''};
